import createAction from 'redux-actions/lib/createAction';

export const REGISTER_DEEP_LINK = 'componentActions/REGISTER_DEEP_LINK';

export const registerDeepLinks = createAction(REGISTER_DEEP_LINK);

export const REGISTER_DEEP_LINK_HIDDEN_POSITION =
  'componentActions/REGISTER_DEEP_LINK_HIDDEN_POSITION';
export const registerDeepLinksHiddenPosition = createAction(REGISTER_DEEP_LINK_HIDDEN_POSITION);
